<template>
    <div>
        <div>
            <div class="d-flex justify-space-between mb-4">
                <div>
                    <div class="page-title mb-2">ระบบประเมินระดับเทคโนโลยี TCCL</div>
                </div>
                <div class="d-flex flex-column gap-12">
                    <div class="d-flex gap-12">
                        <div style="max-width: 250px">
                            <TextField hide-details placeholder="ค้นหา" append-icon="ic:baseline-search"
                                @onChange="keyword = $event" @onEnter="getDataSearch()"></TextField>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-end  mb-8">
            <Button @click="$router.push({ name: 'TechnologyEvaluationCreate' })">+ เพิ่มกิจกรรม</Button>
        </div>
        <div class="d-flex justify-space-between mb-3 px-6">
            <div v-for="(item, i) in tableHeader" :key="i" :style="{ 'width': item.width }"
                :class="['text-' + (item.align ? item.align : 'start')]">
                {{ item.name }}
            </div>
        </div>

        <div>
            <div class="list-layout ">
                <TechEvalItem v-for="(item, i) in data" :key="i" :item="item" :index="i" :headers="headers"
                    @onUpdateStatus="(status) => onUpdateStatus(status, item.id)"></TechEvalItem>
            </div>
        </div>
        
    </div>
</template>

<script>
import TextField from "@/components/input/TextField.vue";
import TechEvalItem from "../../components/TechEvalItem.vue";
import Button from '@/components/input/Button'
import { Icon } from "@iconify/vue2";
import { ta } from "date-fns/locale";

export default {
    name: 'TechnologyEvaluation',
    components: {
        Icon,
        Button,
        TextField,
        TechEvalItem
    },
    data() {
        return {
            keyword: "",
            data: [
                {
                    no: 1,
                    projectCode: "PRJ-001",
                    projectName: "ระบบ IoT เพื่อการเกษตร",
                    fiscalYear: "2568",
                    plan: "ABCD",
                    researcher: "ดร. สมชาย ใจดี",
                    budget: "1,200,000",
                    incashPercent: "80%",
                    recordedDate: "2025-07-20",
                    status: "ดำเนินการ",
                },
                {
                    no: 2,
                    projectCode: "PRJ-001",
                    projectName: "ระบบ IoT เพื่อการเกษตร",
                    fiscalYear: "2568",
                    plan: "ABCD",
                    researcher: "ดร. สมชาย ใจดี",
                    budget: "1,200,000",
                    incashPercent: "80%",
                    recordedDate: "2025-07-20",
                    status: "ดำเนินการ",
                },
                {
                    no: 3,
                    projectCode: "PRJ-001",
                    projectName: "ระบบ IoT เพื่อการเกษตร",
                    fiscalYear: "2568",
                    plan: "ABCD",
                    researcher: "ดร. สมชาย ใจดี",
                    budget: "1,200,000",
                    incashPercent: "80%",
                    recordedDate: "2025-07-20",
                    status: "ดำเนินการ",
                },
            ],
            tableHeader: [
                {
                    name: '',
                    width: '6%',
                    align: 'center'

                },
                {
                    name: 'ลำดับ',
                    width: '4%',
                    align: 'center'

                },
                {
                    name: 'รหัสโครงการ',
                    width: '10%',
                    align: 'left'
                },
                {
                    name: 'ชื่อโครงการ',
                    width: '16%',
                    align: 'left'
                },
                {
                    name: 'ปีงบประมาณ',
                    width: '6%',
                    align: 'center'
                },
                {
                    name: 'แผนงาน',
                    width: '8%',
                    align: 'center'
                },
                {
                    name: 'นักวิจัย',
                    width: '12%',
                    align: 'left'
                },
                {
                    name: 'งบประมาณ',
                    width: '11%',
                    align: 'center'
                },
                {
                    name: '%Incash',
                    width: '9%',
                    align: 'center'
                },
                {
                    name: 'วันที่บันทึก',
                    width: '11%',
                    align: 'center'
                },
                {
                    name: 'สถานะ',
                    width: '7%',
                    align: 'center'
                },
            ],
            headers: [
                { text: "", value: "index", width: "6%", align: "center" },
                { text: "ลำดับ", value: "index", width: "4%", align: "center" },
                { text: "รหัสโครงการ", value: "projectCode", width: "10%", align: "left" },
                { text: "ชื่อโครงการ", value: "projectName", width: "16%", align: "left" },
                { text: "ปีงบประมาณ", value: "fiscalYear", width: "6%", align: "center" },
                { text: "แผนงาน", value: "plan", width: "8%", align: "center" },
                { text: "นักวิจัย", value: "researcher", width: "12%", align: "left" },
                { text: "งบประมาณ", value: "budget", width: "11%", align: "center" },
                { text: "%Incash", value: "incashPercent", width: "9%", align: "center" },
                { text: "วันที่บันทึก", value: "recordedDate", width: "11%", align: "center" },
                { text: "สถานะ", value: "status", width: "7%", align: "center" },
            ],
        };
    },
    created() {
        // this.getData();
    },
    methods: {
        async getData(month = null, year = null) {

            let res = await this.$apiFire("TechnologyEvaluation/index", {
                keyword: this.keyword,
            });
            if (res) {
                this.data = res.data;
            } else {
                this.data = [];
            }

            this.$nextTick(() => {
            });
        },
        async onUpdateStatus(status, id) {

        },
    },
}
</script>

<style lang="scss" scoped>
.list-layout {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
</style>